<template>
  <select
    v-bind="$attrs"
    :value="value"
    :disabled="disabled"
    class="h-8 max-h-8 min-h-6 w-full rounded-sm border bg-black/20 px-2.5 text-xs text-[#e5eefc] transition-[border-color,box-shadow] duration-150 outline-none disabled:bg-[#151b21] disabled:text-slate-400 border-[#2a333d] focus:border-[#ffaa00] focus:shadow-[0_0_0_2px_rgba(255,170,0,0.18)]"
    v-on="forwardedListeners"
    @change="$emit('input', $event.target.value)"
  >
    <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
    <option
      v-for="option in options"
      :key="option.value"
      :value="option.value"
    >
      {{ option.label }}
    </option>
  </select>
</template>

<script>
export default {
  name: "UiSelect",
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    forwardedListeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
  },
};
</script>
